interface Props {
  mode?: 'guest' | 'authed';
  initial?: string;
  onClick?: () => void;
  ariaLabel?: string;
  /** Tailwind height/width utilities for the button box. Defaults to the desktop size. */
  sizeClass?: string;
}

/**
 * Premium-mode account control. Replaces the playful UserMascot with a
 * restrained, designer-grade icon: a circular hairline-bordered button
 * holding a thin line-art user glyph (guest) or a serif monogram (authed).
 * No blush, hearts, tongue or pointer-tracking — opera, not cartoon.
 * The cartoon mascot is still used in playful style mode.
 */
export default function UserAccountButton({
  mode,
  initial,
  onClick,
  ariaLabel = 'Mon compte',
  sizeClass = 'h-11 w-11',
}: Props) {
  const authed = mode === 'authed' && !!initial;
  return (
    <button
      type="button"
      data-fx-mute
      onClick={onClick}
      aria-label={ariaLabel}
      title={ariaLabel}
      className={`group inline-flex items-center justify-center ${sizeClass} rounded-full bg-paper border border-[var(--border-color)] text-ink cursor-pointer transition-[transform,box-shadow,border-color,background-color] duration-200 hover:-translate-y-[1px] hover:border-[var(--mint)] hover:shadow-[var(--shadow-stamp-sm)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--mint)]`}
    >
      {authed ? (
        <span className="font-display text-[15px] leading-none tracking-[0.03em] transition-colors duration-200 group-hover:text-[var(--mint)]">
          {initial}
        </span>
      ) : (
        <svg
          viewBox="0 0 24 24"
          className="w-[19px] h-[19px] transition-colors duration-200 group-hover:text-[var(--mint)]"
          aria-hidden="true"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="8.4" r="3.5" />
          <path d="M5.6 19.4c0-3.7 2.9-5.9 6.4-5.9s6.4 2.2 6.4 5.9" />
        </svg>
      )}
    </button>
  );
}
